import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const routePath = useLocation();

  function disableSmoothScroll() {
    const el = document.createElement("style");
    el.textContent = "* { scroll-behavior: initial !important; }";
    document.head.appendChild(el);
    return () => el.remove();
  }

  useEffect(() => {
    const undoScrollHack = disableSmoothScroll();
    window.scroll({ top: 0 });
    undoScrollHack();
  }, [routePath]);

  return null;
}
